import Button from 'antd/es/button';
import { Space } from 'antd';
import { GraphinContext } from '@antv/graphin';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import React, { useContext } from 'react';
export const GraphZoomButtons = () => {
    const { graph } = useContext(GraphinContext);
    const handleOnZoomIn = () => {
        var _a, _b;
        const app = graph.findById('app');
        const salesforce = graph.findById('salesforce');
        const center = app || salesforce;
        const centerModel = center === null || center === void 0 ? void 0 : center.getModel();
        const zoom = graph.getZoom() || 1;
        graph.zoomTo(zoom + 0.25, {
            x: (_a = centerModel === null || centerModel === void 0 ? void 0 : centerModel.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = centerModel === null || centerModel === void 0 ? void 0 : centerModel.y) !== null && _b !== void 0 ? _b : 0
        }, true);
    };
    const handleOnZoomOut = () => {
        var _a, _b;
        const app = graph.findById('app');
        const salesforce = graph.findById('salesforce');
        const center = app || salesforce;
        const centerModel = center === null || center === void 0 ? void 0 : center.getModel();
        const zoom = graph.getZoom() || 1;
        graph.zoomTo(zoom - 0.25, {
            x: (_a = centerModel === null || centerModel === void 0 ? void 0 : centerModel.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = centerModel === null || centerModel === void 0 ? void 0 : centerModel.y) !== null && _b !== void 0 ? _b : 0
        }, true);
    };
    return (React.createElement(Space, { direction: 'horizontal', size: 4 },
        React.createElement(Button, { icon: React.createElement(PlusOutlined, null), id: 'zoom-in-button', onClick: handleOnZoomIn }),
        React.createElement(Button, { icon: React.createElement(MinusOutlined, null), id: 'zoom-out-button', onClick: handleOnZoomOut })));
};
